import { ActivityLogTab } from "@features/ax/shared/ActivityLog";
import { NotesTab } from "@features/ax/shared/NotesTab";
import { Tabs } from "@shared/ui/tabs";
import React from "react";
import { useParams } from "react-router-dom";
import { ConditionsRisksTab } from "./ConditionAssessmentTab/AssetConditionTab";
import { AssetDetailsTab } from "./Details/AssetDetailsTab";
import { AssetDocumentsTab } from "./DocumentsTab/AssetDocumentsTab";
import { AssetMaintenanceTab } from "./O&MTab/AssetMaintenanceTab";
import { AssetPerformanceTab } from "./PerformanceTab/AssetPerformanceTab";
import { ReadingHistoryTab } from "./ReadingHistory/readingHistory";
import { SchedulesTab } from "./SchedulesTab/scheduleTab";

interface AssetTabsProps {
  data: any;
}

const assetTypeForUnit = [
  "Electrical & Power#1_Utility Electrical Meter#2",
  "Electrical & Power#16_Generator#19",
  "Renewable Sources (NEW)#16_Solar Panels#17",
  "Renewable Sources (NEW)#16_Wind Mills (Wind Turbines)#38",
];
export const AssetTabs: React.FC<AssetTabsProps> = ({ data }) => {
  const source = "1";
  const { id, energyAsset } = useParams();

  // Build an ordered list
  const tabsInOrder = [
    {
      key: "performance",
      config: {
        label: "Performance",
        component: <AssetPerformanceTab />,
        shortLabel: "Perf",
      },
    },
    {
      key: "details",
      config: {
        label: "Details",
        component: <AssetDetailsTab data={data} />,
        shortLabel: "Details",
      },
    },
    {
      key: "condition",
      config: {
        label: "Condition & Risk",
        component: <ConditionsRisksTab data={data} />,
        shortLabel: "Cond",
      },
    },
    {
      key: "schedules",
      config: {
        label: "Schedules",
        component: <SchedulesTab />,
        shortLabel: "Sched",
      },
    },
    {
      key: "maintenance",
      config: {
        label: "O&M",
        component: <AssetMaintenanceTab data={data} />,
        shortLabel: "O&M",
      },
    },
  ];

  // 👉 Insert reading tab ONLY IF energyAsset exists
  if (energyAsset) {
    tabsInOrder.push({
      key: "reading",
      config: {
        label: "Reading History",
        component: <ReadingHistoryTab />,
        shortLabel: "Read",
      },
    });
  }

  // Continue remaining tabs
  tabsInOrder.push(
    {
      key: "documents",
      config: {
        label: "Files & Documents",
        component: <AssetDocumentsTab data={data?.uploadedDocuments} />,
        shortLabel: "Docs",
      },
    },
    {
      key: "notes",
      config: {
        label: "Notes",
        component: <NotesTab requestId={id} source={source} title="Asset" />,
        shortLabel: "Notes",
      },
    },
    {
      key: "activity",
      config: {
        label: "Activity Log",
        component: <ActivityLogTab entityId={id} entityType={source} />,
        shortLabel: "Activity",
      },
    }
  );

  // Convert ordered array → object
  const tabComponents = Object.fromEntries(
    tabsInOrder.map((t) => [t.key, t.config])
  );

  return (
    <div className="w-full">
      <Tabs
        tabComponents={tabComponents}
        defaultValue="performance"
        tabsListClassName="grid w-full grid-cols-9 mb-6"
        tabsListFullWidth
      />
    </div>
  );
};
